import React from 'react';

import * as BulkAssemblyConstants from '../BulkAssemblyConstants';

export default function PositionalEndpointOptions({
  endpoint,
  handlePositionalEndpointChange,
}: {
  endpoint: BulkAssemblyConstants.ConcatenationEndpoint | BulkAssemblyConstants.GibsonEndpoint;
  handlePositionalEndpointChange: (changes: {position: number} | {bases: string}) => void;
}): JSX.Element {
  return (
    <div className="bulkAssemblyEditor-slotEditor-endpoint-optionsContainer">
      <div className="radio">
        <label>
          <input
            type="radio"
            checked={endpoint.position != null}
            onChange={() => {
              handlePositionalEndpointChange({position: 0});
            }}
          />
          Start / end of sequence
        </label>
      </div>
      <div className="u-vertical-center-items radio">
        <label>
          <input
            type="radio"
            checked={endpoint.bases != null}
            onChange={() => {
              handlePositionalEndpointChange({bases: ''});
            }}
          />
          Search for bases:
        </label>
        <input
          type="text"
          className="u-flex-grow u-small-spacing-left"
          onChange={(e) => {
            handlePositionalEndpointChange({bases: e.target.value});
          }}
          value={endpoint.bases || ''}
        />
      </div>
    </div>
  );
}
